import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export default function FinancialYearBasicInfoComponent({
  handleInnerFormChange, selectedFinancialYears, id
}: any) {

  return (
    <>
      <AccordionContainer
        child={
          <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              isDisabled={id !== '0'}
              label="FinYear Description"
              name="FinYearDescription"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'FinYearDescription',
                )
              }}
              type="text"
              value={selectedFinancialYears?.FinYearDescription}
            />
            <InputContainer
              isDisabled={id !== '0'}
              label="FinYear Start Date"
              name="FinYearStartDate"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'FinYearStartDate'
                )
              }}
              type="date"
              value={selectedFinancialYears?.FinYearStartDate}
            />
            <InputContainer
              isDisabled={id !== '0'}
              label="FinYear End Date"
              name="FinYearEndDate"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'FinYearEndDate'
                )
              }}
              type="date"
              value={selectedFinancialYears?.FinYearEndDate}
            />
            <InputContainer
              isDisabled={id !== '0'}
              label="Book Begin Date"
              name="BookBeginDate"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'BookBeginDate'
                )
              }}
              type="date"
              value={selectedFinancialYears?.BookBeginDate}
            />
            <InputContainer
              isDisabled={selectedFinancialYears?.IsFYCompleted === 'true'}
              label="FinYear Completed"
              name="IsFYCompleted"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'IsFYCompleted'
                )
              }}
              type="checkbox"
              value={selectedFinancialYears?.IsFYCompleted}
            />
          </div>
        }
        expandedPanel="userInfo"
        headerTitle="Basic Information"
      />
    </>
  )
}